import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSElement,
  WSGrid,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubRecentPay } from "../../types";

const EMPTY_VALUE = "—";

type Props = {
  recentPay: PaystubRecentPay;
  onViewPaystub?: () => void;
};

export const RecentPayCard: React.FC<Props> = ({
  recentPay,
  onViewPaystub
}) => {
  const netBreakdown = [
    { label: "Gross amount", amount: recentPay.grossAmount },
    { label: "Taxes", amount: recentPay.taxes },
    { label: "Benefits", amount: recentPay.benefits }
  ];

  return (
    <WSCard
      header={{
        label: recentPay.payPeriodLabel,
        value: {
          action: {
            label: "View paystub",
            onClick: onViewPaystub
          }
        }
      }}
    >
      <WSGrid gutter="L">
        <WSGrid.Item span={{ s: "12", l: "6" }}>
          <WSList gap="S">
            <WSInfoBox>
              <WSText.Paragraph color="gray600" mb="XS" weight="medium">
                Net payment amount
              </WSText.Paragraph>
              <WSText.Heading1 color="gray500" weight="book">
                {formatMoney(recentPay.netAmount, Currency.USD)}
              </WSText.Heading1>
            </WSInfoBox>

            <WSInfoBox>
              <WSList gap="S">
                {netBreakdown.map(item => (
                  <WSDataItem
                    key={item.label}
                    inline
                    label={item.label}
                    value={formatMoney(item.amount, Currency.USD)}
                  />
                ))}
              </WSList>
            </WSInfoBox>
          </WSList>
        </WSGrid.Item>

        <WSGrid.Item span={{ s: "12", l: "6" }}>
          <WSGrid gutter="L">
            <WSGrid.Item span={{ s: "12", l: "6" }}>
              <WSList gap="XL">
                <WSDataItem
                  label="Pay date"
                  value={
                    recentPay.payDate
                      ? toWSDateString(recentPay.payDate, "monthDayYear")
                      : EMPTY_VALUE
                  }
                />
                <WSElement>
                  <WSText.ParagraphSm color="gray500" mb="XS">
                    Payment method
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm>
                    {recentPay.payoutMethodLabel}
                  </WSText.ParagraphSm>
                  <WSText.ParagraphSm>
                    {recentPay.payoutAccountLabel}
                  </WSText.ParagraphSm>
                </WSElement>
              </WSList>
            </WSGrid.Item>

            <WSGrid.Item span={{ s: "12", l: "6" }}>
              <WSList gap="XL">
                <WSDataItem
                  label="Worklog"
                  value={`${recentPay.workLogsCount} worklogs included`}
                />
                <WSDataItem
                  label="Percentage"
                  value={`${recentPay.payoutPercentage}%`}
                />
              </WSList>
            </WSGrid.Item>
          </WSGrid>
        </WSGrid.Item>
      </WSGrid>
    </WSCard>
  );
};
